<div class="betbuilder-market-card">
    <div class="ambassador-image" *ngIf="market.ambassador && market.ambassador.image">
        <img [src]="market.ambassador.image" [alt]="market.ambassador.name" />
        <div class="ambassador-name" *ngIf="showName">{{ market.ambassador.name }}</div>
    </div>
    <div class="legs">
        <div class="market-leg" *ngFor="let leg of marketLegs">
            <div class="circle-overlay">
                <div class="theme-radio-off"></div>
            </div>
            <span class="leg">{{ leg }}</span>
        </div>
    </div>
    <div class="betbuilder-option">
        <div class="grid-option">
            <ms-betbuilder-pick
                class="grid-option-selectable"
                [event]="event"
                [fixtureId]="fixtureId"
                [betBuilderMarket]="market"
                [trackingSource]="pickTrackingSource">
                <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="market.option.optionPrice.nativePrice | msNativePriceFormatter" />
            </ms-betbuilder-pick>
        </div>
    </div>
</div>

<ms-betbuilder-edit-pre-created-bab-button *ngIf="market.longIds?.length" [fixtureId]="fixtureId" [event]="event" [market]="market" />
